<template lang="pug">
  div
    v-breadcrumbs.grey.lighten-4.pb-1.pt-2.rc-breadcrumb(divider="/" :items="routes")
      template(slot="item" slot-scope="props")
        router-link.subheading(:to="props.item.to" v-if="props.item.text")
          |{{ capitalize($t(`breadcrumb.${props.item.text}`, props.item.text)) }}
</template>

<script>
export default {
  i18nOptions: { namespaces: ['routing'] },
  computed: {
    routes() {
      return this.$store.state.routes.breadcrumbs.filter(it => !!it.text);
    },
  },
  methods: {
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
};
</script>

<style lang="scss">
.rc-breadcrumb {
  a {
    text-decoration: none;
    color: var(--primary);
    &:last-child {
      color: grey;
      cursor: default;
    }
  }
}
</style>
